<template>
  <div>
    <b-card>
      <b-card-header class="bg-info">
        <b-card-title>ویرایش فرایند</b-card-title>
      </b-card-header>
      <b-card-body>
        <b-overlay :show="onProgressEdit">
          <b-form @submit.prevent>
            <b-row>
              <b-col md="4">
                <b-form-group
                    label="عنوان روند"
                >
                  <b-form-input
                      v-model="title"
                      placeholder="عنوان فرایند  را وارد کنید"
                  />
                </b-form-group>
              </b-col>

            </b-row>
            <b-row>
              <b-col md="6">
                <b-form-checkbox
                    v-model="processActive"
                    :checked="processActive"
                    name="check-button"
                    switch
                    inline
                    class="custom-control-success"
                >
                  فعال
                </b-form-checkbox>
              </b-col>
            </b-row>

            <b-row class="mt-2">
              <b-col>
                <b-tabs
                    ref="tabs"
                    v-model="currentTabIndex"
                    pills
                    lazy
                >
                  <b-tab
                      v-for="(tab,index) in tabs"
                      :key="'dyn-tab-' + index"
                      :title="tab.title"
                  >
                    <b-row class="my-2">
                      <b-col md="6">
                        <b-form-checkbox
                            v-model="tab.active"
                            :checked="tab.active"
                            name="check-button"
                            switch
                            inline
                        >
                          فعال
                        </b-form-checkbox>
                      </b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col md="4">
                        <b-form-group
                            label="عنوان مجموعه"
                            description="برای ویرایش عنوان مجموعه مقدار ورودی را تغییر دهید."
                        >
                          <b-form-input
                              v-model="tab.title"
                              placeholder="عنوان مجموعه  را وارد کنید"
                          />
                        </b-form-group>
                      </b-col>

                    </b-row>
                    <b-row>
                      <b-col cols="4">
                        <b-overlay :show="rolesList.length === 0">
                          <b-form-group>
                            <label for="role">
                              <feather-icon
                                  icon="PocketIcon"
                              />
                              نقش درخواست دهنده
                            </label>
                            <v-select
                                v-model="tab.requesters.roles"
                                multiple
                                dir="rtl"
                                label="slug"
                                :options="rolesList"
                                :reduce="role => role.id"
                                :close-on-select="false"
                            />
                          </b-form-group>
                        </b-overlay>
                      </b-col>
                      <b-col cols="4">
                        <b-overlay :show="permissionList.length === 0">
                          <b-form-group>
                            <label for="permissions">
                              <feather-icon
                                  icon="CheckSquareIcon"
                              />
                              دسترسی درخواست دهنده
                            </label>
                            <v-select
                                v-model="tab.requesters.permissions"
                                multiple
                                dir="rtl"
                                label="slug"
                                :options="permissionList"
                                :reduce="permission => permission.id"
                                :close-on-select="false"
                            />
                          </b-form-group>
                        </b-overlay>
                      </b-col>
                      <b-col md="4">
                        <b-form-group>
                          <label for="permissions">
                            <feather-icon
                                icon="UsersIcon"
                            />
                            کاربران درخواست دهنده
                          </label>
                          <b-overlay :show="!getReceivers">
                            <v-select
                                v-model="tab.requesters.users"
                                multiple
                                dir="rtl"
                                label="name"
                                :options="receiversList"
                                :reduce="receiver => receiver.id"
                                :close-on-select="false"
                            />
                          </b-overlay>
                        </b-form-group>
                      </b-col>

                      <b-col
                          v-if="Object.keys(tab.tree).length"
                          cols="12"
                      >
                        <vue2-org-tree
                            :data="tab.tree"
                            :label-width="200"
                            :label-class-name="labelClass"
                            :render-content="renderContent"
                            selected-class-name="selected-node"
                            selected-key="selectedKey"
                            @on-node-click="onNodeClick"
                        />

                      </b-col>
                      <b-col
                          v-else
                          cols="12"
                      >
                        <b-button
                            v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                            variant="outline-success"
                            class="mt-0 mt-md-2"
                            @click="createFirstNode(index)"
                        >
                          <feather-icon
                              icon="CheckIcon"
                              class="mr-25"
                          />
                          <span>ایجاد تأیید کننده</span>
                        </b-button>
                      </b-col>
                    </b-row>

                    <hr>
                    <b-row>
                      <b-col cols="12">
                        <b-button
                            v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                            variant="outline-warning"
                            class="mt-0 mt-md-2"
                            @click="createFinisher(index)"
                        >
                          <feather-icon
                              icon="CheckIcon"
                              class="mr-25"
                          />
                          <span>ایجاد اتمام کننده</span>
                        </b-button>

                        <b-badge
                            v-if="tab.finisher && tab.finisher.title"
                            variant="light-info"
                            class=" ml-1"
                        >اتمام
                          کننده
                          :
                          {{ tab.finisher.title }}
                        </b-badge>
                        <b-badge
                            v-if="tab.finisher && tab.finisher.needConfirm !== null"
                            :variant="`light-${tab.finisher.needConfirm ? 'success' : 'danger'}`"
                            class=" ml-1"
                        >نیاز
                          به تآیید : {{ tab.finisher.needConfirm ? 'دارد' : 'ندارد' }}
                        </b-badge>
                      </b-col>
                    </b-row>
                    <hr>
                    <div class="my-2">
                      <b-row
                          v-for="(item, index) in tab.items"
                          :id="index"
                          :key="index"
                          ref="row"
                      >

                        <!-- Item Name -->
                        <b-col md="3">
                          <b-form-group
                              label="نام انگلیسی"
                              label-for="item-name"
                          >
                            <b-form-input
                                id="item-name"
                                v-model="item.name"
                                type="text"
                                placeholder="نام را به انگلیسی وارد کنید"
                            />
                          </b-form-group>
                        </b-col>

                        <!-- Item Title -->
                        <b-col md="3">
                          <b-form-group
                              label="عنوان"
                              label-for="item-title"
                          >
                            <b-form-input
                                id="item-title"
                                v-model="item.title"
                                type="text"
                                placeholder="عنوان را وارد کنید"
                            />
                          </b-form-group>
                        </b-col>

                        <!-- Item help -->
                        <b-col md="4">
                          <b-form-group
                              label="راهنما"
                              label-for="item-help"
                          >
                            <b-form-input
                                id="item-help"
                                v-model="item.help"
                                type="text"
                                placeholder="راهنما را وارد نمایید"
                            />
                          </b-form-group>
                        </b-col>

                        <!-- Profession -->

                        <!-- Remove Button -->
                        <b-col
                            lg="2"
                            md="3"
                            class="mb-50"
                        >
                          <b-button
                              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                              variant="outline-danger"
                              class="mt-0 mt-md-2"
                              @click="removeItem(tab,index)"
                          >
                            <feather-icon
                                icon="XIcon"
                                class="mr-25"
                            />
                            <span>حذف</span>
                          </b-button>
                        </b-col>
                        <b-col cols="12">
                          <hr>
                        </b-col>
                      </b-row>
                      <b-button
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          variant="primary"
                          @click="repeateAgain(tab)"
                      >
                        <feather-icon
                            icon="PlusIcon"
                            class="mr-25"
                        />
                        <span>فیلد جدید</span>
                      </b-button>
                    </div>

                    <b-row>
                      <b-col md="12">
                        <b-form-group
                            label="متن فرایند"
                        >
                          <div>
                            <quill-editor
                                v-model="tab.content"
                                :options="editorOption"
                            />
                          </div>

                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-tab>

                  <!-- New Tab Button (Using tabs-end slot) -->
                  <template #tabs-end>
                    <b-nav-item
                        role="presentation"
                        @click.prevent="newTab"
                    >
                      <b>+ موضوع روند جدید</b>
                    </b-nav-item>
                  </template>

                  <!-- Render this if no tabs -->
                  <template #empty>
                    <div class=" text-muted">
                      هیچ موضوعی وجود ندارد! <br> برای شروع روند حداقل یک موضوع ایجاد نمایید.
                    </div>
                  </template>
                </b-tabs>

              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col cols="12">
                <hr>
                <b-button
                    variant="success"
                    :disabled="onProgress"
                    @click="updateProcess"
                >
                  <b-spinner
                      v-if="onProgress"
                      small
                  />
                  {{ onProgress ? 'درحال پردازش فرایند...' : 'ویرایش فرایند ' }}
                </b-button>

              </b-col>

            </b-row>
          </b-form>
        </b-overlay>
      </b-card-body>
    </b-card>

    <b-modal
        id="modal-reply"
        ref="modalReply"
        v-model="showNodeModal"
        :ok-disabled="onProgress"
        cancel-variant="outline-secondary"
        ok-title="انتخاب"
        cancel-title="انصراف"
        centered
        title="اضافه کردن تأیید کننده"
        size="lg"
        :no-close-on-backdrop="true"
        @ok="treeNodeForm"
        @cancel="cancelForm"
        @close="cancelForm"
    >
      <b-form>

        <b-tabs content-class="mt-1">
          <b-tab v-if="this.acceptorType !== 'finisher' && this.acceptorType !== 'starter'">
            <template #title>
              <feather-icon icon="CheckIcon"/>
              <span>تأیید کننده</span>
            </template>
            <b-row class="mt-2">
              <b-col cols="6">
                <b-overlay :show="rolesList.length === 0">
                  <b-form-group>
                    <label for="role">
                      <feather-icon
                          icon="PocketIcon"
                      />
                      نقش کاربر
                    </label>
                    <v-select
                        v-model="acceptor.role_id"
                        dir="rtl"
                        label="slug"
                        :options="rolesList"
                    />
                  </b-form-group>
                </b-overlay>
              </b-col>
              <b-col cols="6">
                <b-overlay :show="permissionList.length === 0">
                  <b-form-group>
                    <label for="permissions">
                      <feather-icon
                          icon="CheckSquareIcon"
                      />
                      لیست دسترسی ها
                    </label>
                    <v-select
                        v-model="acceptor.permission_id"
                        dir="rtl"
                        label="slug"
                        :options="permissionList"
                    />
                  </b-form-group>
                </b-overlay>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <label for="permissions">
                    <feather-icon
                        icon="UserCheckIcon"
                    />
                    کاربر تأیید کننده
                  </label>
                  <b-overlay :show="!getReceivers">
                    <v-select
                        v-model="acceptor.user_id"
                        dir="rtl"
                        label="name"
                        :options="receiversList"
                    />
                  </b-overlay>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <label for="permissions">
                    <feather-icon
                        icon="ClockIcon"
                    />
                    مهلت پاسخ
                  </label>
                  <v-select
                      v-model="processTime"
                      dir="rtl"
                      label="title"
                      :options="processTimeList"
                      :reduce="ptime => ptime.value"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab
              v-if="acceptorType ==='operator' || this.acceptorType === 'operator-starter'"
              lazy
          >
            <template #title>
              <feather-icon icon="EditIcon"/>
              <span>بازنگر</span>
            </template>

            <b-row class="mt-2">
              <b-col cols="6">
                <b-overlay :show="rolesList.length === 0">
                  <b-form-group>
                    <label for="role">
                      <feather-icon
                          icon="PocketIcon"
                      />
                      نقش کاربر
                    </label>
                    <v-select
                        v-model="reviewer.role_id"
                        dir="rtl"
                        label="slug"
                        :options="rolesList"
                    />
                  </b-form-group>
                </b-overlay>
              </b-col>
              <b-col cols="6">
                <b-overlay :show="permissionList.length === 0">
                  <b-form-group>
                    <label for="permissions">
                      <feather-icon
                          icon="CheckSquareIcon"
                      />
                      لیست دسترسی ها
                    </label>
                    <v-select
                        v-model="reviewer.permission_id"
                        dir="rtl"
                        label="slug"
                        :options="permissionList"
                    />
                  </b-form-group>
                </b-overlay>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <label for="permissions">
                    <feather-icon
                        icon="UserIcon"
                    />
                    بازنگر
                  </label>
                  <b-overlay :show="!getReceivers">
                    <v-select
                        v-model="reviewer.user_id"
                        dir="rtl"
                        label="name"
                        :options="receiversList"
                    />
                  </b-overlay>
                </b-form-group>
              </b-col>

            </b-row>
          </b-tab>
          <b-tab v-if="this.acceptorType === 'starter' || this.acceptorType === 'operator-starter' ">
            <template #title>
              <feather-icon icon="UserCheckIcon"/>
              <span>شروع کننده</span>
            </template>
            <b-row class="mt-2">
              <b-col cols="6">
                <b-overlay :show="rolesList.length === 0">
                  <b-form-group>
                    <label for="role">
                      <feather-icon
                          icon="PocketIcon"
                      />
                      نقش کاربر
                    </label>
                    <v-select
                        v-model="starter.role_id"
                        dir="rtl"
                        label="slug"
                        :options="rolesList"
                    />
                  </b-form-group>
                </b-overlay>
              </b-col>
              <b-col cols="6">
                <b-overlay :show="permissionList.length === 0">
                  <b-form-group>
                    <label for="permissions">
                      <feather-icon
                          icon="CheckSquareIcon"
                      />
                      لیست دسترسی ها
                    </label>
                    <v-select
                        v-model="starter.permission_id"
                        dir="rtl"
                        label="slug"
                        :options="permissionList"
                    />
                  </b-form-group>
                </b-overlay>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <label for="permissions">
                    <feather-icon
                        icon="UserCheckIcon"
                    />
                    کاربر تأیید کننده
                  </label>
                  <b-overlay :show="!getReceivers">
                    <v-select
                        v-model="starter.user_id"
                        dir="rtl"
                        label="name"
                        :options="receiversList"
                    />
                  </b-overlay>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <label for="permissions">
                    <feather-icon
                        icon="ClockIcon"
                    />
                    مهلت پاسخ
                  </label>
                  <v-select
                      v-model="starterTime"
                      dir="rtl"
                      label="title"
                      :options="processTimeList"
                      :reduce="ptime => ptime.value"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab>
            <template #title>
              <feather-icon icon="PlusIcon"/>
              <span>ایجاد فرزند</span>
            </template>
            <b-row class="mt-2">
              <b-col cols="6">
                <b-overlay :show="rolesList.length === 0">
                  <b-form-group>
                    <label for="role">
                      <feather-icon
                          icon="PocketIcon"
                      />
                      نقش کاربر
                    </label>
                    <v-select
                        v-model="childNode.role_id"
                        dir="rtl"
                        label="slug"
                        :options="rolesList"
                    />
                  </b-form-group>
                </b-overlay>
              </b-col>
              <b-col cols="6">
                <b-overlay :show="permissionList.length === 0">
                  <b-form-group>
                    <label for="permissions">
                      <feather-icon
                          icon="CheckSquareIcon"
                      />
                      لیست دسترسی ها
                    </label>
                    <v-select
                        v-model="childNode.permission_id"
                        dir="rtl"
                        label="slug"
                        :options="permissionList"
                    />
                  </b-form-group>
                </b-overlay>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <label for="permissions">
                    <feather-icon
                        icon="UserCheckIcon"
                    />
                    کاربر تأیید کننده
                  </label>
                  <b-overlay :show="!getReceivers">
                    <v-select
                        v-model="childNode.user_id"
                        dir="rtl"
                        label="name"
                        :options="receiversList"
                    />
                  </b-overlay>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <label for="userType">
                    <feather-icon
                        icon="UserCheckIcon"
                    />
                    نوع عملیات
                  </label>
                  <v-select
                      v-model="childNode.type"
                      dir="rtl"
                      :options="operationList"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <label for="permissions">
                    <feather-icon
                        icon="ClockIcon"
                    />
                    مهلت پاسخ
                  </label>
                  <v-select
                      v-model="starterTime"
                      dir="rtl"
                      label="title"
                      :options="processTimeList"
                      :reduce="ptime => ptime.value"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>

      </b-form>
    </b-modal>
    <b-modal
        v-model="showFinisherModal"
        :ok-disabled="onProgress"
        cancel-variant="outline-secondary"
        ok-title="انتخاب"
        cancel-title="انصراف"
        centered
        title="اضافه کردن اتمام کننده"
        size="lg"
        :no-close-on-backdrop="true"
        @ok="finisherForm"
        @cancel="cancelForm"
        @close="cancelForm"
    >
      <b-form>

        <b-tabs content-class="mt-1">
          <b-row class="mt-2">
            <b-col cols="6">
              <b-overlay :show="rolesList.length === 0">
                <b-form-group>
                  <label for="role">
                    <feather-icon
                        icon="PocketIcon"
                    />
                    نقش کاربر
                  </label>
                  <v-select
                      v-model="finisher.role"
                      dir="rtl"
                      label="slug"
                      :options="rolesList"
                  />
                </b-form-group>
              </b-overlay>
            </b-col>
            <b-col cols="6">
              <b-overlay :show="permissionList.length === 0">
                <b-form-group>
                  <label for="permissions">
                    <feather-icon
                        icon="CheckSquareIcon"
                    />
                    لیست دسترسی ها
                  </label>
                  <v-select
                      v-model="finisher.permission"
                      dir="rtl"
                      label="slug"
                      :options="permissionList"
                  />
                </b-form-group>
              </b-overlay>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="finishUser">
                  <feather-icon
                      icon="UserIcon"
                  />
                  کاربر تمام کننده
                </label>
                <b-overlay :show="!getReceivers">
                  <v-select
                      id="finishUser"
                      v-model="finisher.user"
                      dir="rtl"
                      label="name"
                      :options="receiversList"
                  />
                </b-overlay>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="acceiptorConfirm">
                  <feather-icon
                      icon="CheckSquareIcon"
                  />
                  نیاز به تأیید
                </label>
                <v-select
                    id="acceiptorConfirm"
                    v-model="finisher.needConfirm"
                    dir="rtl"
                    label="title"
                    :options="finisherConfirmList"
                    :reduce="confirm => confirm.value"
                />
              </b-form-group>
            </b-col>

          </b-row>
        </b-tabs>

      </b-form>
    </b-modal>
    <b-modal
        id="modal-set"
        ref="modalSet"
        v-model="showSetModal"
        :ok-disabled="onSetProgress"
        cancel-variant="outline-secondary"
        :ok-title="onSetProgress ? 'در حال ایجاد': 'ایجاد مجموعه'"
        cancel-title="انصراف"
        centered
        title="ایجاد مجموعه جدید"
        size="md"
        @ok="createSetForm"
        @cancel="cancelSetForm"
    >
      <validation-observer
          #default="handleSubmit"
          ref="refFormObserver"
      >
        <b-form @submit.stop.prevent="handleSubmit">

          <b-row>

            <b-col>

              <div>
                <validation-provider
                    #default="validationContext"
                    name="عنوان"
                    rules="required"
                >
                  <b-form-group
                      label="عنوان مجموعه"
                  >
                    <b-form-input
                        v-model="set.title"
                        autofocus
                        :state="getValidationState(validationContext)"
                        trim
                        placeholder="عنوان مجموعه  را وارد کنید"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </div>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-modal>
  </div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'

import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardBody,
  BForm,
  BFormGroup,
  BFormInput,
  BOverlay,
  BCardTitle,
  BSpinner,
  BButton,
  BFormFile,
  BFormTextarea,
  BTabs,
  BTab,
  BNavItem, BFormInvalidFeedback,
  BBadge, BFormCheckbox,
} from 'bootstrap-vue'
import VSelect from 'vue-select'
import {quillEditor} from 'vue-quill-editor'
import {ValidationProvider, ValidationObserver, localize} from 'vee-validate'
import farsi from 'vee-validate/dist/locale/fa'
import Ripple from 'vue-ripple-directive'
import {requestAnimFrame} from 'leaflet/src/core/Util'
import {makeKey} from 'echarts/lib/component/axisPointer/modelHelper'
import Vue2OrgTree from '@/views/components/org-tree/org-tree.vue'
import {debounce} from '@/libs/debounce'
import {required} from '@core/utils/validations/validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import {heightTransition} from '@core/mixins/ui/transition'
import {doubleRaf, getMillisecond} from '@/libs/utils'
import Tree from '@/views/extensions/tree/Tree.vue'
import log from "echarts/src/scale/Log";

export default {
  name: 'ProcessEdit',
  components: {
    BFormCheckbox,
    BFormInvalidFeedback,
    ValidationProvider,
    Vue2OrgTree,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BForm,
    BFormGroup,
    BFormInput,
    BOverlay,
    VSelect,
    BCardTitle,
    BSpinner,
    BButton,
    BFormFile,
    quillEditor,
    BFormTextarea,
    BTabs,
    BTab,
    BNavItem,
    ValidationObserver,
    BBadge,
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
      onProgressEdit: false,
      title: '',
      processActive: true,
      getReceivers: false,
      receiversList: [],
      receivers: [],
      onProgress: false,
      onSetProgress: false,
      content: '',
      editorOption: {
        theme: 'snow',
        placeholder: 'متن پیام را وارد کنید',
      },
      showNodeModal: false,
      tabs: [],
      tabCounter: 1,
      showSetModal: false,
      set: {
        title: '',
        editingTitle: '',
      },
      currentTabIndex: -1,
      starter: {
        user_id: null,
        role_id: null,
        permission_id: null,
      },
      acceptor: {
        user_id: null,
        role_id: null,
        permission_id: null,
      },
      reviewer: {
        user_id: null,
        role_id: null,
        permission_id: null,
      },
      childNode: {
        user_id: null,
        role_id: null,
        permission_id: null,
        type: 'acceptor',
      },
      selectedNodeId: null,
      acceptorType: 'starter',
      rolesList: [],
      permissionList: [],
      finisher: {
        user: null,
        role: null,
        permission: null,
        needConfirm: null,
        title: null,
      },
      showFinisherModal: false,
      processTime: null,
      starterTime: null,
      reviewProcessTime: null,
      finisherConfirmList: [
        {
          value: 1,
          title: 'دارد',
        },
        {
          value: 0,
          title: 'ندارد',
        },

      ],
      processTimeList: [
        {
          value: 0,
          title: 'غیرفعال',
        },
        {
          value: 10,
          title: '10 دقیقه',
        },
        {
          value: 15,
          title: '15 دقیقه',
        },
        {
          value: 30,
          title: '30 دقیقه',
        },
        {
          value: 60,
          title: '1 ساعت',
        },
      ],
      operationList: ['acceptor', 'reviewer'],
    }
  },
  watch: {
    'starter.user_id': function (newValue, oldValue) {
      if (oldValue === null && Object.keys(newValue).length) {
        this.starter.role_id = null
        this.starter.permission_id = null
      }
    },
    'starter.role_id': function (newValue, oldValue) {
      if (oldValue === null && Object.keys(newValue).length) {
        this.starter.user_id = null
        this.starter.permission_id = null
      }
    },
    'starter.permission_id': function (newValue, oldValue) {
      if (oldValue === null && Object.keys(newValue).length) {
        this.starter.user_id = null
        this.starter.role_id = null
      }
    },
    'acceptor.user_id': function (newValue, oldValue) {
      if (oldValue === null && Object.keys(newValue).length) {
        this.acceptor.role_id = null
        this.acceptor.permission_id = null
      }
    },
    'acceptor.role_id': function (newValue, oldValue) {
      if (oldValue === null && Object.keys(newValue).length) {
        this.acceptor.user_id = null
        this.acceptor.permission_id = null
      }
    },
    'acceptor.permission_id': function (newValue, oldValue) {
      if (oldValue === null && Object.keys(newValue).length) {
        this.acceptor.user_id = null
        this.acceptor.role_id = null
      }
    },
    'reviewer.user_id': function (newValue, oldValue) {
      if (oldValue === null && Object.keys(newValue).length) {
        this.reviewer.role_id = null
        this.reviewer.permission_id = null
      }
    },
    'reviewer.role_id': function (newValue, oldValue) {
      if (oldValue === null && Object.keys(newValue).length) {
        this.reviewer.user_id = null
        this.reviewer.permission_id = null
      }
    },
    'reviewer.permission_id': function (newValue, oldValue) {
      if (oldValue === null && Object.keys(newValue).length) {
        this.reviewer.user_id = null
        this.reviewer.role_id = null
      }
    },
    'finisher.user': function (newValue, oldValue) {
      if (typeof newValue !== 'undefined' && newValue !== null) {
        this.finisher.role = null
        this.finisher.permission = null
        this.finisher.title = `کاربر ${newValue.name}`
      }
    },
    'finisher.role': function (newValue, oldValue) {
      if (typeof newValue !== 'undefined' && newValue !== null) {
        this.finisher.user = null
        this.finisher.permission = null
        this.finisher.title = ` نقش ${newValue.slug}`
      }
    },
    'finisher.permission': function (newValue, oldValue) {
      if (typeof newValue !== 'undefined' && newValue !== null) {
        this.finisher.role = null
        this.finisher.user = null
        this.finisher.title = `دسترسی  ${newValue.slug}`
      }
    },
    'childNode.user_id': function (newValue, oldValue) {
      if (oldValue === null && Object.keys(newValue).length) {
        this.childNode.role_id = null
        this.childNode.permission_id = null
      }
    },
    'childNode.role_id': function (newValue, oldValue) {
      if (oldValue === null && Object.keys(newValue).length) {
        this.childNode.user_id = null
        this.childNode.permission_id = null
      }
    },
    'childNode.permission_id': function (newValue, oldValue) {
      if (oldValue === null && Object.keys(newValue).length) {
        this.childNode.user_id = null
        this.childNode.role_id = null
      }
    },
  },

  mounted() {
    this.getPermissions()
    this.getRoles()
    this.getRelatedUsers()
    this.getProcess()
  },
  created() {
    localize('fa', {
      messages: farsi.messages,
    })
  },
  methods: {
    repeateAgain(tab) {
      tab.nextTodoId += 1
      tab.items.push({
        id: null,
        name: null,
        title: null,
        help: null,
      })
    },
    removeItem(tab, index) {
      tab.items.splice(index, 1)
      tab.nextTodoId -= 1
    },
    closeTab(x) {
      for (let i = 0; i < this.tabs.length; i += 1) {
        if (this.tabs[i] === x) {
          this.tabs.splice(i, 1)
        }
      }
    },
    newTab() {
      this.showSetModal = true
    },
    EditTabForm() {
      this.tabs[this.currentTabIndex].title = this.set.editingTitle
    },

    labelClass(data) {
      return (data.type).toLowerCase() === 'acceptor' ? 'bg-success' : 'bg_node'
    },
    renderContent(h, data) {
      return h('div', [
        h('feather-icon', {
          attrs: {
            icon: this.renderType((data.type).toLowerCase()),
          },
        }),
        h('span', {
          attrs: {
            class: 'px-1',
          },
        }, data.name),
      ])
    },
    renderType(type) {
      let title = ''
      switch (type) {
        case 'starter':
          title = ''
          break
        case 'acceptor':
          title = 'CheckIcon'
          break
        case 'reviewer':
          title = 'EditIcon'
          break
        default:
          title = ''
      }

      return title
    },
    onNodeClick(e, data) {
      this.selectedNodeId = data.key
      this.$set(data, 'selectedKey', !data.selectedKey ?? true)

      if ((data.type).toLowerCase() === 'starter') {
        this.createNode(data)
      }
      data.children.map(obj => {
        this.createNode(obj)
      })

      this.showNodeModal = true
      if ((data.type).toLowerCase() === 'starter') {
        this.acceptorType = 'operator-starter'
      } else {
        this.acceptorType = 'operator'
      }
    },
    findNodeById(nodes, id) {
      for (const node of nodes) {
        if (node.key === id) {
          return node
        }
        if (node.children) {
          const foundNode = this.findNodeById(node.children, id)
          if (foundNode) {
            return foundNode
          }
        }
      }
      return null
    },
    createFirstNode(tabIndex) {
      this.acceptorType = 'starter'
      this.showNodeModal = true
    },

    createFinisher(tabIndex) {
      this.acceptorType = 'finisher'

      this.showFinisherModal = true

      const currentTab = this.tabs[tabIndex]

      this.finisher = currentTab.finisher || null
    },

    async updateProcess() {
      this.onProgress = true

      await this.$http.put(`processes/${this.$route.params.id}`, {
        title: this.title,
        active: this.processActive,
        tabs: this.tabs,
      }, {})
          .then(({data}) => {
            if (data.status) {
              this.getProcess()
              this.$bvToast.toast('فرایند  با موفقیت ثبت شد', {
                title: 'انجام درخواست',
                toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
                variant: 'success',
              })
            } else {
              this.$bvToast.toast(data.message ?? 'ثبت فرایند  انجام نشد', {
                title: 'حطا',
                toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
                variant: 'danger',
              })
            }
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message ?? error.message, {
              title: 'خطا در دریافت اطلاعات',
              toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
              variant: 'danger',
            })
          })
          .finally(() => {
            this.onProgress = false
          })
    },

    createSetForm(bvModalEvt) {
      bvModalEvt.preventDefault()

      this.handleSubmit()

      doubleRaf(() => {
        this.currentTabIndex = this.tabs.length + 1
        this.showSetModal = false
      })
    },

    async handleSubmit() {
      if (this.set.title) {
        this.$refs.modalReply.hide()
        await this.createTab()
        this.set.title = ''
      }
    },

    createTab() {
      this.tabs.push({
        id: null,
        title: this.set.title,
        active: true,
        receivers: [],
        tree: {},
        items: [],
        nextTodoId: 1,
        finisher: {},
        requesters: {
          roles: [],
          permissions: [],
          users: [],
        },
      })
    },

    cancelSetForm() {
    },

    treeNodeForm(bvModalEvt) {
      bvModalEvt.preventDefault()

      const currentTab = this.tabs[this.currentTabIndex]
      let tree = JSON.parse(JSON.stringify(currentTab.tree))

      if (!Object.keys(tree).length) {
        tree = this.prepareNode(tree, 'starter', 'starter')
      }
      if (this.selectedNodeId !== null) {
        if (tree.key === this.selectedNodeId) {
          if (this.childNode.permission_id || this.childNode.user_id || this.childNode.role_id) {
            this.prepareNode(tree, 'childNode', this.childNode.type)
          } else {
            this.prepareNode(tree, 'starter', 'starter')
            this.prepareNode(tree, 'acceptor', 'acceptor')
            this.prepareNode(tree, 'reviewer', 'reviewer')
          }
        } else {
          let selectedNode = this.findNodeById(tree.children, this.selectedNodeId)

          // Check if the selected node exists
          if (selectedNode) {
            if (!selectedNode.children) {
              selectedNode.children = [] // If the selected node doesn't have children, create an empty array for them
            }
            if (this.childNode.permission_id || this.childNode.user_id || this.childNode.role_id) {
              selectedNode = this.prepareNode(selectedNode, 'childNode', this.childNode.type)
            } else {
              selectedNode = this.prepareNode(selectedNode, 'acceptor', 'acceptor')
              selectedNode = this.prepareNode(selectedNode, 'reviewer', 'reviewer')
            }
          }
        }
      }

      currentTab.tree = JSON.parse(JSON.stringify(tree))
      this.showNodeModal = false
      this.clearTreeData()
    },

    clearTreeData() {
      this.starter = {
        user_id: null,
        role_id: null,
        permission_id: null,
      }
      this.acceptor = {
        user_id: null,
        role_id: null,
        permission_id: null,
      }
      this.reviewer = {
        user_id: null,
        role_id: null,
        permission_id: null,
      }
      this.childNode = {
        user_id: null,
        role_id: null,
        permission_id: null,
        type: 'acceptor',
      }
      this.selectedNodeId = null
      this.processTime = null
    },

    finisherForm() {
      const currentTab = this.tabs[this.currentTabIndex]
      currentTab.finisher = {
        user_id: this.finisher.user?.id ?? null,
        role_id: this.finisher.role?.id ?? null,
        permission_id: this.finisher.permission?.id ?? null,
        needConfirm: this.finisher.needConfirm,
        title: this.finisher.title,
      }

      this.finisher = {
        user: null,
        role: null,
        permission: null,
        needConfirm: null,
        title: null,
      }
    },

    updateOrCreateNode(node, itemSelect, type, model, dataType = '') {
      const item = JSON.parse(JSON.stringify(itemSelect))

      let nameKey = 'name'
      const idKey = model
      let processAfter = 0
      switch (model) {
        case 'role_id':
          nameKey = 'slug'
          break
        case 'permission_id':
          nameKey = 'slug'
          break
      }
      if (type === 'acceptor') {
        processAfter = this.processTime !== null ? this.processTime : (itemSelect?.process_after ?? 0)
      }
      if (type === 'starter') {
        processAfter = this.starterTime !== null ? this.starterTime : (itemSelect?.process_after ?? 0)
      }

      if (Object.keys(node).length) {
        if ((node.type).toLowerCase() === 'starter' && type === 'starter') {
          node.name = item[nameKey]
          node.role_id = null
          node.permission_id = null
          node.user_id = null
          node[idKey] = item.id
          node.process_after = processAfter
        }
        if (type !== 'starter') {
          const nodeObj = node.children.find(obj => (obj.type).toLowerCase() === type)
          const nodeObjIndex = node.children.findIndex(obj => (obj.type).toLowerCase() === type)
          if (dataType == 'childNode') {
            if (nodeObjIndex >= 0) {
              node.children.splice(nodeObjIndex)
            }
            node.children.push({
              key: getMillisecond(),
              name: item[nameKey],
              [idKey]: item.id,
              type,
              process_after: processAfter,
              children: nodeObj ? [nodeObj] : [],
            })

          } else if (nodeObj) {
            nodeObj.name = item[nameKey]
            nodeObj.role_id = null
            nodeObj.permission_id = null
            nodeObj.user_id = null
            nodeObj[idKey] = item.id
            nodeObj.process_after = processAfter
          } else {
            node.children.push({
              key: getMillisecond(),
              name: item[nameKey],
              [idKey]: item.id,
              type,
              process_after: processAfter,
              children: [],
            })
            // }
          }
        }
      } else {
        node = {
          key: getMillisecond(),
          name: item[nameKey],
          [idKey]: item.id,
          type,
          process_after: this.processTime ?? 0,
          children: [],
        }
      }
      return node
    },

    removeNode(node, type) {
      const nodeObj = node.children.find(obj => (obj.type).toLowerCase() === type)
      const children = typeof nodeObj !== 'undefined' ? nodeObj.children : []
      if (nodeObj) {
        node.children.splice(nodeObj, 1)
        if (children.length > 0) {
          node.children = children

        }
      }
      return node
    },
    setTicketId(id, modal) {
      this.ticketId = id
      this[modal] = true
    },
    cancelForm() {
      this.clearTreeData()
    },

    getRoles() {
      this.$http.get('user/roles?paginate=false')
          .then(({data}) => {
            if (data.status) {
              this.rolesList = data.roles
            } else {
              this.$bvToast.toast(data.message ?? 'دریافت لیست نقش ها با خطا مواجه شد', {
                title: 'خطا در دریافت اطلاعات',
                toaster: 'b-toaster-top-right',
                variant: 'danger',
              })
            }
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: 'b-toaster-top-right',
              variant: 'danger',
            })
          })
    },
    getPermissions() {
      this.$http.get('user/permissions?paginate=false')
          .then(({data}) => {
            this.permissionList = data.permissions
          })
          .catch(() => {
            this.$bvToast.toast('ارتباط با وبسرویس انجام نشد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: 'b-toaster-top-right',
              variant: 'danger',
            })
          })
    },
    async getRelatedUsers() {
      await this.$http.get('user/list')
          .then(({data}) => {
            this.receiversList = data
            this.getReceivers = true
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
              variant: 'danger',
            })
          })
    },
    async getProcess() {
      this.onProgressEdit = true
      await this.$http.get(`processes/${this.$route.params.id}`)
          .then(({data}) => {
            this.title = data.title
            this.processActive = !!data.active
            this.tabs = data.tabs
            this.finisher = data.tabs[0].finisher
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
              variant: 'danger',
            })
          })
          .finally(() => {
            this.onProgressEdit = false
          })

      doubleRaf(() => {
        if (typeof this.$route.query.mainId !== 'undefined' && (this.$route.params.id !== this.$route.query.mainId)) {
          this.currentTabIndex = this.tabs.findIndex((tab) => tab.id === this.$route.query.mainId)
        }
      })
    },
    /**
     * data types are acceptor and reviewer
     * node type are acceptor and reviewer and starter
     * @param tree
     * @param dataType
     * @param nodeType
     * @returns {*}
     */
    prepareNode(tree, dataType, nodeType) {
      const node = Object.entries(this[dataType])
      let hasAccept = false
      for (const [key, value] of node) {
        if (key !== 'type' && value !== null) {
          tree = this.updateOrCreateNode(tree, value, nodeType, key, dataType)
          hasAccept = true
          break
        }
      }
      if (!hasAccept && dataType !== 'childNode') {
        tree = this.removeNode(tree, nodeType)
      }

      return tree
    },
    createNode(obj) {
      const type = (obj.type).toLowerCase()
      // obj type are acceptor and reviewer
      const nodeKeys = Object.keys(this[type])
      // keys are user_id,role_id,permission_id
      for (const key of nodeKeys) {
        if (obj[key]) {
          this[type][key] = {id: obj[key]}

          switch (key) {
            case 'user_id':
              this[type][key].name = obj.name
              break
            case 'role_id':
            case 'permission_id':
              this[type][key].slug = obj.name
              break
          }
          break
        }
      }

      if (obj.type === 'acceptor' || (obj.type).toLowerCase() === 'acceptor') {
        this.processTime = obj.process_after || 0
      }
      if (obj.type === 'starter' || (obj.type).toLowerCase() === 'starter') {
        this.starterTime = obj.process_after || 0
      }
    },
  },
  setup() {
    const {
      getValidationState,

    } = formValidation(name)

    return {
      getValidationState,
    }
  },
}
</script>

<style lang="scss" scoped>
.repeater-form {
  overflow: hidden;
  transition: .35s height;
}
</style>
